<script setup lang="ts">
defineProps({
  as: {
    type: [String, Object, Function],
    default: 'div'
  },
  yPadding: {
    type: String,
    default: 'base'
  },
  collapsible: {
    type: Boolean,
    default: true
  }
})
</script>

<template>
  <Component
    :is="as"
    :data-collapsible="collapsible || null"
    class="pa-bounded"
    :class="{
      'pa-bounded--xs': yPadding === 'xs',
      'pa-bounded--sm': yPadding === 'sm',
      'pa-bounded--base': yPadding === 'base',
      'pa-bounded--lg': yPadding === 'lg',
      'pa-bounded--flat': yPadding === 'flat',
    }"
  >
    <div class="pa-bounded__container">
      <slot />
    </div>
  </Component>
</template>

